import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ThemeProvider } from "./hooks/useTheme";
import { ModalProvider } from "./hooks/useModal";

function App() {
  return (
    <ThemeProvider>
      <ModalProvider>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </I18nextProvider>
      </ModalProvider>
    </ThemeProvider>
  );
}

export default App;
